{
  "whitepaper": {
    "ja": "2021-12-27 11:43"
  }
}